import { defineMessages } from "./define.js";

/** Лента изменений: who did what, and when (SPEC §4.6). */
export const activity = defineMessages("activity", {
  title: { ru: "Лента изменений", en: "Activity" },
  subtitle: {
    ru: "Кто что добавил, выполнил и удалил. Новое сверху.",
    en: "Who added, finished and deleted what. Newest first.",
  },

  empty: {
    ru: "Пока ничего не происходило. Как только что-нибудь появится, оно окажется здесь.",
    en: "Nothing has happened yet. The moment something does, it turns up here.",
  },
  loading: { ru: "Загружаем…", en: "Loading…" },

  /**
   * Lower case on purpose: these sit in a heading that is upper-cased in CSS,
   * next to a date from Intl that is lower case too — `common.today` is the
   * sentence-leading pair and would read as a different word here.
   */
  today: { ru: "сегодня", en: "today" },
  yesterday: { ru: "вчера", en: "yesterday" },

  /** A member who has since left the space is honestly "somebody". */
  someone: { ru: "Кто-то", en: "Someone" },

  /**
   * What happened, as one sentence per kind and verb.
   *
   * The name is a placeholder inside the phrase rather than a bold prefix glued
   * onto a fragment, because the two languages put it in different places: the
   * Russian names the thing after a colon and keeps the verb impersonal, while
   * the English simply says who did it. Split into «{name}: » + «добавлен
   * пункт» the English would come out as "Anya: item added".
   *
   * Russian past tense agrees with the speaker's gender — "добавил" or
   * "добавила" — and nothing here knows anyone's gender; a display name is all
   * a member has. A short passive participle agrees with the *object* instead,
   * whose gender is fixed by its kind and known at compile time. So the feed
   * says «Аня: добавлена хотелка» rather than guessing, and never renders
   * "добавил(а)". English has no such trap, so it is plain active voice.
   */
  listCreated: { ru: "{name}: создан список", en: "{name} started a list" },
  listUpdated: { ru: "{name}: изменён список", en: "{name} edited a list" },
  listCompleted: { ru: "{name}: завершён список", en: "{name} finished a list" },
  listDeleted: { ru: "{name}: удалён список", en: "{name} deleted a list" },

  itemCreated: { ru: "{name}: добавлен пункт", en: "{name} added an item" },
  itemUpdated: { ru: "{name}: изменён пункт", en: "{name} edited an item" },
  itemCompleted: { ru: "{name}: выполнен пункт", en: "{name} ticked off an item" },
  itemDeleted: { ru: "{name}: удалён пункт", en: "{name} deleted an item" },

  wishCreated: { ru: "{name}: добавлена хотелка", en: "{name} added a wish" },
  wishUpdated: { ru: "{name}: изменена хотелка", en: "{name} edited a wish" },
  wishCompleted: { ru: "{name}: исполнена хотелка", en: "{name} granted a wish" },
  wishDeleted: { ru: "{name}: удалена хотелка", en: "{name} deleted a wish" },

  messageCreated: { ru: "{name}: написано сообщение", en: "{name} wrote a message" },
  messageUpdated: { ru: "{name}: изменено сообщение", en: "{name} edited a message" },
  messageCompleted: { ru: "{name}: закрыто сообщение", en: "{name} closed a message" },
  messageDeleted: { ru: "{name}: удалено сообщение", en: "{name} deleted a message" },

  eventCreated: { ru: "{name}: создано событие", en: "{name} added an event" },
  eventUpdated: { ru: "{name}: изменено событие", en: "{name} edited an event" },
  eventCompleted: { ru: "{name}: прошло событие", en: "{name} held an event" },
  eventDeleted: { ru: "{name}: удалено событие", en: "{name} deleted an event" },

  topicCreated: { ru: "{name}: создана тема", en: "{name} started a thread" },
  topicUpdated: { ru: "{name}: изменена тема", en: "{name} edited a thread" },
  topicCompleted: { ru: "{name}: закрыта тема", en: "{name} resolved a thread" },
  topicDeleted: { ru: "{name}: удалена тема", en: "{name} deleted a thread" },
});
